import { buildEnvSignature, captureEnvironment } from "./utils"
import { loadCalibration } from "./storage"
import { EEGCalibrationStatus, EEGCalibrationRecord, EEGCalibrationState } from "./types"

export const missingCalibrationState: EEGCalibrationState = {
	status: EEGCalibrationStatus.MISSING,
}

export const evaluateCalibrationStatus = (
	record?: EEGCalibrationRecord,
): EEGCalibrationStatus => {
	if (!record) return EEGCalibrationStatus.MISSING

	const currentEnv = captureEnvironment()
	if (!currentEnv) return EEGCalibrationStatus.MISSING

	return buildEnvSignature(currentEnv) === buildEnvSignature(record.env)
		? EEGCalibrationStatus.VALID
		: EEGCalibrationStatus.OUTDATED
}

export const createCalibrationState = (
	record: EEGCalibrationRecord,
	storageKey: string,
): EEGCalibrationState => ({
	record,
	storageKey,
	status: evaluateCalibrationStatus(record),
})

export const initializeCalibrationState = (): EEGCalibrationState => {
	const loaded = loadCalibration()
	return loaded ? createCalibrationState(loaded.record, loaded.key) : missingCalibrationState
}
